import { MagnifyingGlassIcon } from '@heroicons/react/24/solid'
import React from 'react'

function SearchInput({ ...props }) {
  return (
    <div className="bg-white rounded-full shadow flex items-center relative flex-grow">
      <small className="absolute left-2">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
      </small>
      <input
        type="search"
        className="rounded-full w-full text-gray-500 px-9 py-2 outline-none ring-0 focus:shadow-md focus:shadow-general-teal/10 transition-all disabled:cursor-not-allowed placeholder:text-sm placeholder:tracking-wide"
        {...props}
      />
    </div>
  )
}

export default SearchInput